import React, { useEffect, useState } from 'react'
import { Button, Input, Select, Table } from 'antd'
import 'aos/dist/aos.css'
import '../../MainCSS.css'
import { Option } from 'antd/es/mentions'
import axios from 'axios'
import { toast } from 'react-toastify'
import { GetEmployeeMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { SaveEmployeeMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { UpdateEmployeeMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { DeleteEmployeeMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { GetDesignationMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { GetDepartmentMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'

const EmployeeMaster = () => {
  const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };

  const commonHeaders1 = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
    },
  }

  const [errors, setErrors] = useState({
    employeeName: '',
    designationName: '',
    departmentName: '',
    mobileNumber: '',
    address: '',
    status: '',
  })

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const [employeeId, setEmployeeId] = useState('')
  const [employeeName, setEmployeeName] = useState('')
  const [designationName, setDesignationName] = useState('')
  const [departmentName, setDepartmentName] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [address, setAddress] = useState('')
  const [status, setStatus] = useState('')

  const [allDesignation, setAllDesignation] = useState([])
  const [allDepartment, setAllDepartment] = useState([])
  const [allEmployee, setAllEmployee] = useState([])
  const [updateButton, setUpdateButton] = useState(false)
  const [saveButton, setSaveButton] = useState(true)

  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase()

    const filtered = allEmployee.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? '')
          .toLowerCase()
          .includes(searchValue),
      ),
    )

    setFilteredData(filtered)
    setTotalEntries(filtered.length)
    setCurrentPage(1)
  }
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  // Fetch Employee, Designation and Department Names
  let isEmployeeFetched = false
  useEffect(() => {
    if (isEmployeeFetched) return
    fetchEmployee()
    fetchDesignation()
    fetchDepartment()
    isEmployeeFetched = true
  }, [])

  // ==============Get table data================

  let isError = false

  const fetchEmployee = async () => {
    try {
      const response = await axios.get(GetEmployeeMaster, commonHeaders1)
      if (response.data !== null) {
        setAllEmployee(response.data)
        setFilteredData(response.data)
        setTotalEntries(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Employee:', error)
        toast.error('Failed to fetch Employee data')
        isError = true
      }
    }
  }

  // const columns = [
  //   {
  //     title: "Sr.No.",
  //     dataIndex: "",
  //     key: "index",
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: "Employee Name",
  //     dataIndex: "employeeName",
  //     key: "employeeName",
  //   },
  //   {
  //     title: "Designation",
  //     dataIndex: "designationName",
  //     key: "designationName",
  //   },
  //   {
  //     title: "Department",
  //     dataIndex: "departmentName",
  //     key: "departmentName",
  //   },
  //   {
  //     title: "MobileNo",
  //     dataIndex: "mobileNo",
  //     key: "mobileNo",
  //   },
  //   {
  //     title: "Address",
  //     dataIndex: "address",
  //     key: "address",
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "currentStatus",
  //     key: "currentStatus",
  //     render: (status) => (status === 1 ? "Active" : "Inactive"),
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
  //           onClick={() => handleDeleteData(record)}
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ];

  const columns = [
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Employee Name',
      dataIndex: 'employeeName',
      key: 'employeeName',
      sorter: (a, b) => a.employeeName.localeCompare(b.employeeName), // Sorting alphabetically
    },
    {
      title: 'Designation',
      dataIndex: 'designationName',
      key: 'designationName',
      sorter: (a, b) => a.designationName.localeCompare(b.designationName), // Sorting alphabetically
    },
    {
      title: 'Department',
      dataIndex: 'departmentName',
      key: 'departmentName',
      sorter: (a, b) => a.departmentName.localeCompare(b.departmentName), // Sorting alphabetically
    },
    {
      title: 'MobileNo',
      dataIndex: 'mobileNo',
      key: 'mobileNo',
      sorter: (a, b) => a.mobileNo - b.mobileNo, // Sorting numerically (assuming MobileNo is numeric)
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      sorter: (a, b) => a.address.localeCompare(b.address), // Sorting alphabetically
    },
    {
      title: 'Status',
      dataIndex: 'currentStatus',
      key: 'currentStatus',
      render: (status) => (status === 1 ? 'Active' : 'Inactive'),
      sorter: (a, b) => a.currentStatus - b.currentStatus, // Sorting numerically (Active=1, Inactive=0)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <div>
          <span
            type="submit"
            style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
            onClick={() => handleEditDataButton(record)}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </span>
          <span
            type="submit"
            style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
            onClick={() => handleDeleteData(record)}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        </div>
      ),
    },
  ]

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '13px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  const fetchDesignation = async () => {
    try {
      const response = await axios.get(GetDesignationMaster, commonHeaders1)
      if (response.data !== null) {
        setAllDesignation(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Designation:', error)
        toast.error('Failed to fetch Designation data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  const fetchDepartment = async () => {
    try {
      const response = await axios.get(GetDepartmentMaster, commonHeaders1)
      if (response.data !== null) {
        setAllDepartment(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Department:', error)
        toast.error('Failed to fetch Department data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  //=========CANCEL EMPLOYEE DATA============
  const handleCancel = () => {
    setEmployeeName('')
    setDesignationName('')
    setDepartmentName('')
    setMobileNumber('')
    setAddress('')
    setStatus('')
    setUpdateButton(false)
    setSaveButton(true)
    setErrors('')
  }

  //=========SAVE EMPLOYEE DATA============
  const handleSubmit = async () => {
    let isValid = true
    const errorObj = {}

    if (!employeeName.trim()) {
      isValid = false
      errorObj.employeeName = 'Employee Name is required *'
    }
    if (!designationName) {
      isValid = false
      errorObj.designationName = 'Designation Name is required *'
    }
    if (!departmentName) {
      isValid = false
      errorObj.departmentName = 'Department Name is required *'
    }
    if (!mobileNumber.trim()) {
      isValid = false
      errorObj.mobileNumber = 'Mobile No. is required *'
    }
    if (!address.trim()) {
      isValid = false
      errorObj.address = 'Address is required *'
    }
    if (!status.trim()) {
      isValid = false
      errorObj.status = 'Status is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return

    const saveData = {
      employeeName: employeeName,
      designationId: designationName,
      departmentId: departmentName,
      mobileNo: mobileNumber,
      address: address,
      currentStatus: parseFloat(status),
    }

    try {
      const response = await axios.post(
        SaveEmployeeMaster,
        saveData,
        commonHeaders,
      )

      if (response.data === 'CREATED') {
        toast.success('Employee added successfully!')
        fetchEmployee()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Employee already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //=========EDIT EMPLOYEE DATA============
  const handleEditDataButton = (item) => {
    setUpdateButton(true)
    setSaveButton(false)

    setEmployeeId(item.id)
    setEmployeeName(item.employeeName)
    setDesignationName(item.designationName != "-" ? item.designationId : null)
    setDepartmentName(item.departmentName != "-" ? item.departmentId : null)
    setMobileNumber(item.mobileNo)
    setAddress(item.address)
    // setStatus(item.currentStatus ? String(item.currentStatus) : null)
    setStatus(item.currentStatus !== null && item.currentStatus !== undefined ? String(item.currentStatus) : null);

  }

  //=========UPDATE EMPLOYEE DATA============
  const handleUpdate = async () => {
    if (
      !employeeName ||
      !designationName ||
      !departmentName ||
      !mobileNumber ||
      !address ||
      !status
    ) {
      toast.warn('Please fill all fields!')
      return
    }

    const updateData = {
      id: employeeId,
      employeeName: employeeName,
      designationId: designationName,
      departmentId: departmentName,
      mobileNo: mobileNumber,
      address: address,
      currentStatus: parseFloat(status),
    }

    try {
      const response = await axios.put(
        UpdateEmployeeMaster,
        updateData,
        commonHeaders,
      )

      if (response.data === 'UPDATED') {
        toast.success('Employee updated successfully!')
        fetchEmployee()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Employee already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while updating data')
    }
  }

  //=========DELETE EMPLOYEE DATA============
  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Employee "${item.employeeName}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${DeleteEmployeeMaster}?id=${item.id}`,
        commonHeaders1,
      )
      if (response.data === 'DELETED') {
        toast.success('Employee deleted successfully!')
        fetchEmployee()
        handleCancel()
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the Employee')
    }
  }

//====================================

  const statusOptions = [
  { value: '1', label: 'Active' },
  { value: '0', label: 'Inactive' },
]
//====================================

  return (
    <>
      <div className="px-5 py-3">
        <div
          className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
          style={{ backgroundColor: '#e0efff' }}
        >
          <div className="col-12">
            <div className="row px-md-5 mt-3 p-2">
              <div className="col-12 col-lg-3"></div>
              <div className="col-12 col-lg-6">
                <div className="row p-0 m-0">
                  <div className="col-12 py-1">
                    <label className="labels">Employee Name</label>
                    <Input
                      value={employeeName}
                      onChange={(e) => setEmployeeName(e.target.value)}
                      placeholder="Enter Name"
                      maxLength={250}
                    />
                    {errors.employeeName && (
                      <div className="errorField">{errors.employeeName}</div>
                    )}
                  </div>
                </div>

                <div className="row p-0 m-0">
                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Designation</label>
                    <Select
                      value={designationName || undefined}
                      onChange={setDesignationName}
                      showSearch
                      className="w-100"
                      placeholder="Select Designation"
                      optionFilterProp="children"
                    >
                      {allDesignation.map((designation) => (
                        <Option key={designation.id} value={designation.id}>
                          {designation.designationName}
                        </Option>
                      ))}
                    </Select>
                    {errors.designationName && (
                      <div className="errorField">{errors.designationName}</div>
                    )}
                  </div>

                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Department</label>
                    <Select
                      value={departmentName || undefined}
                      onChange={setDepartmentName}
                      showSearch
                      className="w-100"
                      placeholder="Select Department"
                      optionFilterProp="children"
                    >
                      {allDepartment.map((department) => (
                        <Option key={department.id} value={department.id}>
                          {department.departmentName}
                        </Option>
                      ))}
                    </Select>
                    {errors.departmentName && (
                      <div className="errorField">{errors.departmentName}</div>
                    )}
                  </div>
                </div>

                <div className="row p-0 m-0">
                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Mobile Number</label>
                    <Input
                      value={mobileNumber}
                      onChange={(e) => {
                        const value = e.target.value
                        if (/^\d{0,10}$/.test(value)) setMobileNumber(value) // only allow up to 10 digits
                      }}
                      placeholder="Enter Mobile Number"
                      maxLength={10}
                    />
                    {errors.mobileNumber && (
                      <div className="errorField">{errors.mobileNumber}</div>
                    )}
                  </div>

                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Status</label>
                    <Select
                      value={status || undefined}
                      onChange={setStatus}
                      showSearch
                      className="w-100"
                       placeholder="Select Status"
                      optionFilterProp="children"
                    >
                      {statusOptions.map((opt) => (
                        <Option key={opt.value} value={opt.value}>
                          {opt.label}
                        </Option>
                      ))}

                    </Select>
                    {errors.status && (
                      <div className="errorField">{errors.status}</div>
                    )}
                  </div>

                  <div className="col-12 py-1">
                    <label className="labels">Address</label>
                    <Input.TextArea
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      placeholder="Enter Address"
                      maxLength={250}
                    />
                    {errors.address && (
                      <div className="errorField">{errors.address}</div>
                    )}
                  </div>
                </div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  {saveButton && (
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  )}
                  {updateButton && (
                    <Button
                      type="submit"
                      className="UpdateBtn mx-1"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3"></div>

              <div
                className="col-12 p-0 mt-3"
                style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
              ></div>
            </div>

            {/*================ Table =========================*/}
            <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: 'white' }}
              >
                <div
                  className="col-12 px-md-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>
                      Show entries &nbsp;
                    </span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto' }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeMaster
